// Mirrors UserSerializer.validate_password in api/users/serializers/user.py.
// Keep the two in sync: a password the UI accepts but the API rejects
// surfaces as an opaque 400 on save.
export const PASSWORD_SPECIAL_CHARS = '@$!%*?&#^()_+-=';

export const PASSWORD_RULES = [
  {key: 'length', label: 'At least 8 characters long', test: (pw) => pw.length >= 8},
  {key: 'uppercase', label: 'Includes an uppercase letter', test: (pw) => /[A-Z]/.test(pw)},
  {key: 'lowercase', label: 'Includes a lowercase letter', test: (pw) => /[a-z]/.test(pw)},
  {key: 'number', label: 'Includes a number', test: (pw) => /\d/.test(pw)},
  {
    key: 'specialChar',
    label: `Includes one of ${PASSWORD_SPECIAL_CHARS}`,
    test: (pw) => /[@$!%*?&#^()_+\-=]/.test(pw),
  },
];

export const passwordMeetsRules = (pw) => PASSWORD_RULES.every((rule) => rule.test(pw));
